import { SectorColours } from '../base-styles/sector-colours';
import { Sector } from '../model/sector';

export function sectorToColour(sector: Sector, hover: boolean = false): string {
  if (sector === Sector.Transport) {
    return hover ? SectorColours.transportHoverColour : SectorColours.transportColour;
  }
  if (sector === Sector.Industry) {
    return hover ? SectorColours.industryHoverColour : SectorColours.industryColour;
  }
  if (sector === Sector.Agriculture) {
    return hover ? SectorColours.agricultureHoverColour : SectorColours.agricultureColour;
  }
  if (sector === Sector.Energy) {
    return hover ? SectorColours.energyHoverColour : SectorColours.energyColour;
  }
  if (sector === Sector.Other) {
    return hover ? SectorColours.otherHoverColour : SectorColours.otherColour;
  }
  if (sector === Sector.Emission) {
    return hover ? SectorColours.emissionHoverColour : SectorColours.emissionColour;
  }
  return hover ? SectorColours.unknownHoverColour : SectorColours.unknownColour;
}
